import React, {Component} from 'react'
import {AlertModal} from "component-modal";
import {HttpError, InterpretedError, NetworkError} from "./Errors";
import {withRouter} from "react-router-dom";
import {cleanError} from "../actions/error";
import {connect} from "react-redux";
import styled from 'styled-components';

const EmailLink = styled.a`
  color: inherit;
  text-decoration: underline;
`

export function withErrorHandler (Component) {
  class WithErrorHandler extends React.Component {
    constructor () {
      super();

      this.state = {
        hasError: false,
        errorTitle: null,
        errorContent: null,
        error: null,
        errorInfo: null
      }
    }

    static displayName = `withErrorHandler(${Component.displayName})`

    componentDidCatch (error, info) {
      this.setState({ hasError: true, error, errorInfo: info });
    }

    errorHandler = {
      /**
       *
       * @param error
       * @param options
       * @returns {boolean} - true only when error is handled properly
       */
      handleError: (error, options) => {
        console.error(error);
        if (error instanceof InterpretedError) {
          if(error instanceof NetworkError) {
            this.setState({
              hasError: true,
              error,
              errorTitle: 'Oops, there seems to be a connection issue',
              errorContent: <React.Fragment>
                Please check your internet and try again, <br/> or you may contact us at <EmailLink href="mailto:support@autovantage.co">support@autovantage.co</EmailLink>.
              </React.Fragment>,
            });
            return true;
          } else if(error instanceof HttpError) {
            if(error.status == 401) {
              // this.props.history && this.props.history.push('/login');
            } else if(error.status >= 400 && error.status < 500) {
              this.setState({
                hasError: true,
                error,
                errorTitle: error.message,
                errorContent: '',
              });
            } else {
              this.setState({
                hasError: true,
                error,
                errorTitle: 'Ops, something wrong with the server',
                errorContent: error.message,
              });
            }
            return true;
          }
        }

        return false;
      }
    };

    render () {
      return <React.Fragment>
        {
          this.state.hasError &&
          <AlertModal isOpen={true}
                      onCloseClicked={e => this.setState({hasError: false, error: null, errorInfo: null, errorTitle: null, errorContent: null})}
                      profile={'ci'}
                      alertTitle={this.state.errorTitle}
                      alertContent={this.state.errorContent} />
        }
        <Component {...this.props} errorHandler={this.errorHandler}/>
      </React.Fragment>
    }
  }

  return withRouter(WithErrorHandler)
}


class ErrorDisplay extends Component {

  render() {
    var {hasError, error, errorTitle, errorContent} = this.props;

    if(hasError && error) {
      if(error.type == 'NetworkError') {
        errorTitle = 'Oops, there seems to be a connection issue';
        errorContent = <React.Fragment>
          Please check your internet and try again, <br/> or you may contact us at <EmailLink href="mailto:support@autovantage.co">support@autovantage.co</EmailLink>.
        </React.Fragment>;
      } else if(error.type == 'HttpError') {
        if(error.status == 401) {
          // this.props.history.push('/login');
          this.props.cleanError();
          return [];
        } else if(error.status >= 400 && error.status < 500) {
          errorTitle = error.message;
        } else {
          errorTitle = 'Ops, something wrong with the server';
          errorContent = error.message;
        }
      } else if(error.type == 'InterpretedError') {
        errorTitle = error.message;
      } else {
        errorTitle = 'Some error occurred, please refresh and try again'
      }

      return <AlertModal isOpen={true}
                         onCloseClicked={this.props.cleanError}
                         profile={'ci'}
                         alertTitle={errorTitle}
                         alertContent={errorContent} />
    }

    return [];
  }

}

export const ConnectedErrorDisplay = connect(function (state) {
  return state && state.error
}, function (dispatch) {
  return {
    cleanError() {
      dispatch(cleanError())
    }
  }
})(withRouter(ErrorDisplay));


// WEBPACK FOOTER //
// ./src/errors/ErrorHandler.js